function nwCcatInit(root) {
  const rows = (root || document).querySelectorAll('[data-nw-ccat-row]');

  for (const row of rows) {
    if (row.dataset.nwCcatReady === 'true') continue;
    row.dataset.nwCcatReady = 'true';

    const wrap = row.closest('.nw-ccat__viewport');
    const prev = wrap?.querySelector('[data-nw-ccat-prev]');
    const next = wrap?.querySelector('[data-nw-ccat-next]');
    if (!prev || !next) continue;

    const step = (dir) => {
      const card = row.firstElementChild;
      const amount = card ? card.getBoundingClientRect().width + 12 : row.clientWidth * 0.8;
      row.scrollBy({ left: dir * amount, behavior: 'smooth' });
    };

    const sync = () => {
      prev.disabled = row.scrollLeft <= 4;
      next.disabled = row.scrollLeft + row.clientWidth >= row.scrollWidth - 4;
    };

    prev.addEventListener('click', () => step(-1));
    next.addEventListener('click', () => step(1));
    row.addEventListener('scroll', sync, { passive: true });
    sync();
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => nwCcatInit());
} else {
  nwCcatInit();
}

document.addEventListener('shopify:section:load', (event) => nwCcatInit(event.target));
